import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import { CustomResultOfPaginatedListOfGetDynamicTemplatesWithPaginationDto } from 'src/app/core/api/models';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { GetDynamicTemplatesWithPaginationDto } from '../../../core/api/models/get-dynamic-templates-with-pagination-dto';
import { PaginatedListOfGetDynamicTemplatesWithPaginationDto } from '../../../core/api/models/paginated-list-of-get-dynamic-templates-with-pagination-dto';
import { DynamicTemplatesService } from '../../../core/api/services/dynamic-templates.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { UpdateDynamicTemplateCommand } from './../../../core/api/models/update-dynamic-template-command';
import { PageNames } from 'src/app/configs/page-names.enum';
import { CommonModule } from '@angular/common';
import { BaseIndexModule } from '../../shared/base';
import { DynamicTemplatesFormComponent } from "./dynamic-templates-form/dynamic-templates-form.component";

@Component({
    selector: 'app-dynamic-templates',
    imports: [BaseIndexModule, DynamicTemplatesFormComponent],
    templateUrl: './dynamic-templates.component.html'
})
export class DynamicTemplatesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.dynamicTemplate;
  protected currentService = inject(DynamicTemplatesService);
  paginationApiMethodName: string = this.currentService.dynamicTemplatesGetDynamicTemplatesWithPagination.name;
  deleteApiMethodName: string = this.currentService.dynamicTemplatesDeleteDynamicTemplate.name;
  createGetApiMethodName: string = this.currentService.dynamicTemplatesCreateDynamicTemplateGet.name;
  auditApiMethodName: string = this.currentService.dynamicTemplatesGetDynamicTemplatesAuditWithPagination.name;
  modelWithPagination$: Observable<PaginatedListOfGetDynamicTemplatesWithPaginationDto>;
  items$: Observable<Array<GetDynamicTemplatesWithPaginationDto>>;
  formPageConfig: FormPageConfig<UpdateDynamicTemplateCommand> = {};

  //#endregion

  ngOnInit() {
    super.ngOnInit();
  }
  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Update_key) {
        this.showUpdate({}, false, +value);
      }
    }
  }
  showUpdate(
    model: GetDynamicTemplatesWithPaginationDto,
    setFiltersAndUrl = true,
    id = 0
  ) {
    if (this.items$) this.onUpdate({}, false, id);
    else
      setTimeout(() => {
        this.showUpdate({}, false, id);
      }, 2000);
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.id, name: 'id', hasSearch: true },
      { title: this.localizer.name, name: 'name', hasSearch: true },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      // { title: this.localizer.format, name: 'format', hasSearch: true },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;
  }

  //#endregion

  // onUpdate(model: GetDynamicTemplatesWithPaginationDto) {
  //   try {
  //     this.pageConfig.isVisibleForm = true;
  //     this.formPageConfig.isEditMode = true;
  //     this.formPageConfig.editData = {
  //       name: model.name,
  //       format: model.format,
  //       id: model.id
  //     };
  //   } catch (error) {
  //     this.loggerService.logError(this.tagName, error, EventTypes.facility)
  //   }

  // }
  onUpdate(
    model: GetDynamicTemplatesWithPaginationDto,
    setFiltersAndUrl = true,
    id = 0
  ) {
    this.showParent = false;
    this.setParentQueryString();
    this.pageConfig.isVisibleForm = true;
    this.formPageConfig.isEditMode = true;
    if (setFiltersAndUrl) {
      this.formPageConfig.editData = {
        name: model.name,
        format: model.format,
        id: model.id,
      };
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Update_key +
          '=' +
          model.id
      );
    } else {
      this.items$.subscribe(
        (items) => {
          this.formPageConfig.editData = {
            name: items.find((item) => item.id == id).name,
            format: items.find((item) => item.id == id).format,
            id: items.find((item) => item.id == id).id,
          };
        },
        (error) => {
          console.error('Error:', error);
        }
      );
    }
  }
}
